import ApplicationController from "./application_controller";
import StimulusReflex from "stimulus_reflex";
import $ from "jquery";

export default class extends ApplicationController {
    static targets = ["hm0_output"];

    connect() {

        super.connect();
        StimulusReflex.register(this);
        console.log("Bons de Commandes controller js en cours ..");
        MicroModal.init();


        var self = this;

        // echeancier
        if (
            $("#partial-echeancier-content").length &&
            $("#partial-echeancier-content").text().trim() == "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.bons_de_commande_echeancier(), 300);
        }
        //di
        if (
            $("#partial-di-content").length &&
            $("#partial-di-content").text().trim() ==
            "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.bons_de_commande_di(), 300);
        }
        //di-termine
        if (
            $("#partial-di-termine-content").length &&
            $("#partial-di-termine-content").text().trim() ==
            "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.bons_de_commande_di_termine(), 300);
        }

        //partial-factures-emises-content
        if (
            $("#partial-factures-emises-content").length &&
            $("#partial-factures-emises-content").text().trim() ==
            "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.bons_de_commande_factures_emises(), 300);
        }


        //partial-interventions-content
        if (
            $("#partial-interventions-content").length &&
            $("#partial-interventions-content").text().trim() ==
            "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.bons_de_commande_interventions_search(), 300);
        }


        //partial-commandes-st-content
        if (
            $("#partial-commandes-st-content").length &&
            $("#partial-commandes-st-content").text().trim() ==
            "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.bons_de_commande_commandes_st(), 300);
        }


        //partial-avancements-content
        if (
            $("#partial-avancements-content").length &&
            $("#partial-avancements-content").text().trim() ==
            "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.bons_de_commande_avancements(), 300);
        }


        //partial-commandes-liees-content
        if (
            $("#partial-commandes-liees-content").length &&
            $("#partial-commandes-liees-content").text().trim() ==
            "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.bons_de_commande_commandes_liees(), 300);
        }


        //partial-factures-fournisseurs-content
        if (
            $("#partial-factures-fournisseurs-content").length &&
            $("#partial-factures-fournisseurs-content").text().trim() ==
            "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.bons_de_commande_factures_fournisseurs(), 300);

        }


        //partial-documents-content
        if (
            $("#partial-documents-content").length &&
            $("#partial-documents-content").text().trim() ==
            "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.bons_de_commande_documents(), 300);

        }


        //partial-primes-content
        if (
            $("#partial-primes-content").length &&
            $("#partial-primes-content").text().trim() ==
            "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.bons_de_commande_primes(), 300);

        }


        //partial-frais-content
        if (
            $("#partial-frais-content").length &&
            $("#partial-frais-content").text().trim() ==
            "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.bons_de_commande_frais(), 300);

        }
        //partial-entretiens-rhs-content
        if (
            $("#partial-entretiens-rhs-content").length &&
            $("#partial-entretiens-rhs-content").text().trim() ==
            "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.bons_de_commande_entretiens_rhs(), 300);

        }
        //partial-historisation-budget-content
        if (
            $("#partial-historisation-budget-content").length &&
            $("#partial-historisation-budget-content").text().trim() ==
            "Chargement en cours ..."
        ) {
            //on est sur le show
            setTimeout(() => this.bons_de_commande_historisation_budget(), 300);
        }


        const rechercheInterventionsMotsCles = document.getElementById('recherche_interventions_mots_cles');
        if (rechercheInterventionsMotsCles) {
            rechercheInterventionsMotsCles.addEventListener('input', () => {
                // Si le champ de texte est vide
                if (rechercheInterventionsMotsCles.value === '') {
                    // Supprimer le paramètre 'intervention_recherche' de l'URL
                    var urlParams = new URLSearchParams(window.location.search);
                    urlParams.delete('intervention_recherche');
                    // Mettre à jour l'URL sans le paramètre supprimé
                    var newUrl = window.location.pathname + '?' + urlParams.toString();
                    window.history.replaceState({}, '', newUrl);
                }
            });
        }
        if ($("#search").length && $("#quick_sort").length) {
            //on est sur la vue list

            //on est sur la vue list
            //  if ($("#activate_em").length) {
            //       this.show_edition_multiple();
            //  }
            this.rerender();
            (function ($) {
                $.each(["show", "hide"], function (i, ev) {
                    var el = $.fn[ev];
                    $.fn[ev] = function () {
                        this.trigger(ev);
                        return el.apply(this, arguments);
                    };
                });
            })(jQuery);
            $("#spinner").on("show", function () {
                $("#total_entries").hide();
            });
            $("#spinner").on("hide", function () {
                $("#total_entries").show();
            });
            $("#filterrific_with_chiffre_daffaires_inf").on("input", function () {
                $("#target_chiffre_daffaires_inf").val(
                    $("#filterrific_with_chiffre_daffaires_inf").val()
                );
            });
            $("#filterrific_with_chiffre_daffaires_sup").on("input", function () {
                $("#target_chiffre_daffaires_sup").val(
                    $("#filterrific_with_chiffre_daffaires_sup").val()
                );
            });
            $("#target_chiffre_daffaires_inf").on("input", function () {
                $("#filterrific_with_chiffre_daffaires_inf").val(
                    $("#target_chiffre_daffaires_inf").val()
                );
            });
            $("#target_chiffre_daffaires_sup").on("input", function () {
                $("#filterrific_with_chiffre_daffaires_sup").val(
                    $("#target_chiffre_daffaires_sup").val()
                );
            });
            $("#mySidebar #table_custom_ .switch input").each(function () {
                let me = $(this);
                if (
                    me.attr("type") === "checkbox" &&
                    me.attr("class").includes("preference_columns")
                ) {
                    me[0].addEventListener("change", (e) => {
                        let hiddenHtmlClass = e.target.id.replace("filterrific_", "");
                        console.log(hiddenHtmlClass);
                        if (e.target.checked) {
                            console.log("show ", e.target);
                            $("." + hiddenHtmlClass).show();
                        } else {
                            console.log("hide ", e.target);
                            $("." + hiddenHtmlClass).hide();
                        }
                    });
                }
            });
            /////


            var targetElement = document.getElementById("mySidebar");
            targetElement.addEventListener("scroll", (event) => {
                var element = document.getElementById("mySidebar");
                document.getElementById("scrollevel").value = element.scrollTop;
            });

            const currentUrl = window.location.href;
            const url = new URL(currentUrl);
            const bonsDeCommandeParam = url.searchParams.get("previous_record");

            if (bonsDeCommandeParam != null) {
                var trElement = $("#bons_de_commande_" + bonsDeCommandeParam);
                $("#bons_de_commande_" + bonsDeCommandeParam + " td").addClass("highlighted-td");
                $("#bons_de_commande_" + bonsDeCommandeParam).get(0).scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }




    }


    iniFla() {
        let fields = document.querySelectorAll(".flatpickr");

        for (let j = 0; j < fields.length; j++) {
            fields[j].classList.add("fx-input-date-sidbar-menu");
        }
    }

    show_edition_multiple() {
        if (this.current_app && this.params) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/bons_de_commandes/show_ajax_edition_multiple?" +
                this.params +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#edition_multiple").html("");
                    $("#edition_multiple").html(text);
                    MicroModal.init();
                })
            );
        }
    }


    //Domaine intervention
    bons_de_commande_di() {
        if (this.current_app && this.bons_de_commande_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/bons_de_commandes/show_ajax_for_hm_domaine_intervention?bons_de_commande_id=" +
                this.bons_de_commande_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-di-content").html("");
                    $("#partial-di-content").html(text);
                    $("#partial-di-badge").html('(' + $('.show_ajax_for_hm_domaine_intervention >tbody >tr:not(.no_record)').length + ')');
                })
            );
        }
    }

    //Domaine d'intervention terminé

    bons_de_commande_di_termine() {
        if (this.current_app && this.bons_de_commande_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/bons_de_commandes/show_ajax_for_hm_domaine_intervention_termine?bons_de_commande_id=" +
                this.bons_de_commande_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-di-termine-content").html("");
                    $("#partial-di-termine-content").html(text);
                    $("#partial-di-termine-badge").html('(' + $('.show_ajax_for_hm_domaine_intervention_termine >tbody >tr:not(.no_record)').length + ')');
                })
            );
        }
    }



    //
    //Echeancier

 

    bons_de_commande_echeancier(event = null) {
         let order = event ? event.target.value : null; // Récupérer order seulement si event existe

         console.log("bons_de_commande_echeancier >>>",order )
    if (event) {
      if (event.type === "change") {
        order = event.target.value; // Pour le select
      } else if (event.type === "click") {
        event.preventDefault();
        order = event.currentTarget.dataset.contactsEmployeSort; // Pour le clic sur un TH
      }
    }
      
        if (this.current_app && this.bons_de_commande_id) {

            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/bons_de_commandes/show_ajax_for_hm_echeancier?bons_de_commande_id=" +
                this.bons_de_commande_id +
                "&vr2=1";


      if (order) {
        url += "&" + event.currentTarget.dataset.target + "=" + encodeURIComponent(order); // Ajouter le tri seulement s'il est défini
      }
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-echeancier-content").html("");
          $("#partial-echeancier-content").html(text);
          $("#partial-echeancier-badge").html(
            "(" +
              $(".show_ajax_for_hm_echeancier >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
           
        }
    }

    //Factures Emises

        bons_de_commande_factures_emises(event = null) {
         let order = event ? event.target.value : null; // Récupérer order seulement si event existe

         console.log("bons_de_commande_factures_emises >>>",order )
    if (event) {
      if (event.type === "change") {
        order = event.target.value; // Pour le select
      } else if (event.type === "click") {
        event.preventDefault();
        order = event.currentTarget.dataset.contactsEmployeSort; // Pour le clic sur un TH
      }
    }
      
        if (this.current_app && this.bons_de_commande_id) {

            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/bons_de_commandes/show_ajax_for_hm_factures_emises?bons_de_commande_id=" +
                this.bons_de_commande_id +
                "&vr2=1";


      if (order) {
        url += "&" + event.currentTarget.dataset.target + "=" + encodeURIComponent(order); // Ajouter le tri seulement s'il est défini
      }
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-factures-emises-content").html("");
          $("#partial-factures-emises-content").html(text);
          $("#partial-factures-emises-badge").html(
            "(" +
              $(".show_ajax_for_hm_factures_emises >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
           
        }
    }

    // bons_de_commande_factures_emises() {
    //     if (this.current_app && this.bons_de_commande_id) {
    //         let url =
    //             window.location.origin +
    //             "/" +
    //             this.current_app +
    //             "/bons_de_commandes/show_ajax_for_hm_factures_emises?bons_de_commande_id=" +
    //             this.bons_de_commande_id +
    //             "&vr2=1";
    //         fetch(url).then((response) =>
    //             response.text().then(function (text) {
    //                 $("#partial-factures-emises-content").html("");
    //                 $("#partial-factures-emises-content").html(text);
    //                 $("#partial-factures-emises-badge").html('(' + $('.show_ajax_for_hm_factures_emises >tbody >tr:not(.no_record)').length + ')');
    //             })
    //         );
    //     }
    // }
    //Interventions
    bons_de_commande_interventions_search() {
        if (this.current_app && this.bons_de_commande_id) {


            let url = `${window.location.origin}/${this.current_app}/bons_de_commandes/show_ajax_for_hm_interventions_search?bons_de_commande_id=${this.bons_de_commande_id}&filterrific=${this.filterrific}&vr2=1`;

            const recherche_interventions_mots_cles_input = document.getElementById("recherche_interventions_mots_cles");

            let intervention_recherche = '';

            if (recherche_interventions_mots_cles_input) {
                const recherche_interventions_mots_cles = recherche_interventions_mots_cles_input.value.trim();

                if (!recherche_interventions_mots_cles) {
                    const urlParams = new URLSearchParams(window.location.search);
                    intervention_recherche = urlParams.get('intervention_recherche');
                    if (intervention_recherche) {
                        url += `&with_intervention_mots_cles=${encodeURIComponent(intervention_recherche)}`;
                    }
                } else {
                    url += `&with_intervention_mots_cles=${encodeURIComponent(recherche_interventions_mots_cles)}`;

                    const urlParams = new URLSearchParams(window.location.search);
                    urlParams.set('intervention_recherche', recherche_interventions_mots_cles);
                    urlParams.set('active_tab', 'interventions');
                    const updatedParams = urlParams.toString();
                    const newUrl = `${window.location.origin}${window.location.pathname}?${updatedParams}`;
                    window.history.replaceState({ path: newUrl }, '', newUrl);
                }
            }

            $("#partial-interventions-content").html("<center>Chargement en cours ... </center>");
            $("#partial-interventions-badge").html("<i class='fa-solid fa-spinner fa-spin fa-sm' style='font-size: 11px'></i>");

            fetch(url)
                .then(response => {
                    if (response.ok) {
                        response.text().then(text => {
                            $("#partial-interventions-content").html("");
                            $('#partial-interventions-content').html(text);
                            $("#partial-interventions-badge").html('(' + $('.show_ajax_for_hm_interventions >tbody >tr:not(.no_record)').length + ')');

                            if (!recherche_interventions_mots_cles_input.value.trim() && intervention_recherche) {
                                recherche_interventions_mots_cles_input.value = intervention_recherche;
                            }
                        });
                    } else {
                        console.error('Erreur lors de la soumission du formulaire 2');
                    }
                })
                .catch(error => {
                    console.error('Erreur lors de la soumission du formulaire 1', error);
                });
        } else {

        }

    }


    show_ajax_for_hm_interventions() {



        if (this.current_app && this.bons_de_commande_id) {


            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/bons_de_commandes/show_ajax_for_hm_interventions?bons_de_commande_id=" +
                this.bons_de_commande_id + "&active_tab=" + this.active_tab + "&filterrific=" + this.filterrific + "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-interventions-content").html("");
                    $("#partial-interventions-content").html(text);
                    $("#partial-interventions-badge").html('(' + $('.show_ajax_for_hm_interventions >tbody >tr:not(.no_record)').length + ')');
                })
            );
            console.log(this.bons_de_commande_id);
            console.log("bons_de_commandeid:", this.bons_de_commande_id);
            console.log("filterrific:", this.filterrific);
            console.log("page:", this.page);
            console.log("filter_param_id:", this.filter_param_id);
            console.log("is_active:", this.is_active);
            console.log("active_tab:", this.active_tab);
        }
    }

    //Commandes Liéés
    bons_de_commande_commandes_liees() {
        if (this.current_app && this.bons_de_commande_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/bons_de_commandes/show_ajax_for_hm_commandes_liees?bons_de_commande_id=" +
                this.bons_de_commande_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-commandes-liees-content").html("");
                    $("#partial-commandes-liees-content").html(text);
                    $("#partial-commandes-liees-badge").html('(' + $('.show_ajax_for_hm_commandes_liees >tbody >tr:not(.no_record)').length + ')');

                })
            );
        }
    }

    //Commandes ST
    bons_de_commande_commandes_st() {
        if (this.current_app && this.bons_de_commande_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/bons_de_commandes/show_ajax_for_hm_commandes_st?bons_de_commande_id=" +
                this.bons_de_commande_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-commandes-st-content").html("");
                    $("#partial-commandes-st-content").html(text);
                    $("#partial-commandes-st-badge").html('(' + $('.show_ajax_for_hm_commandes_st >tbody >tr:not(.no_record)').length + ')');

                })
            );
        }
    }

    //Factures Fournisseurs
    bons_de_commande_avancements() {
        if (this.current_app && this.bons_de_commande_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/bons_de_commandes/show_ajax_for_hm_avancements?bons_de_commande_id=" +
                this.bons_de_commande_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-avancements-content").html("");
                    $("#partial-avancements-content").html(text);
                    $("#partial-avancements-badge").html('(' + $('.show_ajax_for_hm_avancements >tbody >tr:not(.no_record)').length + ')');

                })
            );
        }
    }

    //Factures Fournisseurs
    bons_de_commande_factures_fournisseurs() {
        if (this.current_app && this.bons_de_commande_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/bons_de_commandes/show_ajax_for_hm_factures_fournisseurs?bons_de_commande_id=" +
                this.bons_de_commande_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-factures-fournisseurs-content").html("");
                    $("#partial-factures-fournisseurs-content").html(text);
                    $("#partial-factures-fournisseurs-badge").html('(' + $('.show_ajax_for_hm_factures_fournisseurs >tbody >tr:not(.no_record)').length + ')');

                })
            );
        }
    }

    //Documents
    bons_de_commande_documents() {
        if (this.current_app && this.bons_de_commande_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/bons_de_commandes/show_ajax_for_hm_documents?bons_de_commande_id=" +
                this.bons_de_commande_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-documents-content").html("");
                    $("#partial-documents-content").html(text);
                    $("#partial-documents-badge").html('(' + $('.show_ajax_for_hm_documents >tbody >tr:not(.no_record)').length + ')');

                })
            );
        }
    }


    //Primes
    bons_de_commande_primes() {
        if (this.current_app && this.bons_de_commande_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/bons_de_commandes/show_ajax_for_hm_primes?bons_de_commande_id=" +
                this.bons_de_commande_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-primes-content").html("");
                    $("#partial-primes-content").html(text);
                    $("#partial-primes-badge").html('(' + $('.show_ajax_for_hm_primes >tbody >tr:not(.no_record)').length + ')');

                })
            );
        }
    }

    // Frais
    bons_de_commande_frais() {
        if (this.current_app && this.bons_de_commande_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/bons_de_commandes/show_ajax_for_hm_frais?bons_de_commande_id=" +
                this.bons_de_commande_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-frais-content").html("");
                    $("#partial-frais-content").html(text);
                    $("#partial-frais-badge").html('(' + $('.show_ajax_for_hm_frais >tbody >tr:not(.no_record)').length + ')');

                })
            );
        }
    }
    bons_de_commande_entretiens_rhs() {
        if (this.current_app && this.bons_de_commande_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/bons_de_commandes/show_ajax_for_hm_entretiens_rhs?bons_de_commande_id=" +
                this.bons_de_commande_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-entretiens-rhs-content").html("");
                    $("#partial-entretiens-rhs-content").html(text);
                    $("#partial-entretiens-rhs-badge").html('(' + $('.show_ajax_for_hm_entretiens_rhs >tbody >tr:not(.no_record)').length + ')');
                })
            );
        }
    }

    //Historisation budget
    bons_de_commande_historisation_budget() {
        if (this.current_app && this.bons_de_commande_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/bons_de_commandes/show_ajax_for_hm_historisation_budget?bons_de_commande_id=" +
                this.bons_de_commande_id +
                "&vr2=1";
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-historisation-budget-content").html("");
                    $("#partial-historisation-budget-content").html(text);
                    $("#partial-historisation-budget-badge").html('(' + $('.show_ajax_for_hm_bdc_budget_histos >tbody >tr:not(.no_record)').length + ')');
                })
            );
        }
    }
    //end of Historisation budget


    afterRemovePref(element) {
        console.log("afterRemovePref afterRemovePref afterRemovePref");
        $('.child-loader').show();
        $('#filterrific_filter').submit();
    }

    beforeRemovePref(element) {
        console.log("afterRemovePref afterRemovePref afterRemovePref");
        $('.child-loader').show();
        $('#filterrific_filter').submit();
    }

    afterUpdateView(element) {
        var app = this.current_app;
        var bons_de_commande_id = this.bons_de_commande_id;
        var fragment_element = document.getElementById("ressources_template");
        if (fragment_element) {
            var fragment = fragment_element.content;
            console.log("pilotage_par_budget",$('#bons_de_commande_pilotage_par_budget').is(":checked"));
            if ($('#bons_de_commande_pilotage_par_budget').is(":checked")){
                console.log("pilotage_par_budget is checked setting display none");
                fragment.querySelector(".date_de_debut").style.display = 'none';
                fragment.querySelector(".date_de_fin").style.display = 'none'; 
                fragment.querySelector(".nb_jours_forfait_td").style.display = 'none';
                fragment.querySelector(".nombre_de_jours").style.display = 'none';
                fragment.querySelector(".forfait_mensuel").style.display = 'none';
                fragment.querySelector(".pilotage_par_budget_hidden").value = 1;
            }else{
                console.log("pilotage_par_budget is not checked setting display block");
                fragment.querySelector(".date_de_debut").style.display = '';
                fragment.querySelector(".date_de_fin").style.display = '';
                fragment.querySelector(".nb_jours_forfait_td").style.display = '';
                fragment.querySelector(".nombre_de_jours").style.display = '';
                fragment.querySelector(".forfait_mensuel").style.display = '';
                fragment.querySelector(".pilotage_par_budget_hidden").value = 0;
            }
            var fragment = fragment_element.content;
            var date_de_debut = fragment.querySelector(
                "#bons_de_commande_ressources_attributes_NEW_RECORD_date_de_debut"
            );
            var date_de_fin = fragment.querySelector(
                "#bons_de_commande_ressources_attributes_NEW_RECORD_date_de_fin"
            );
            let dateDebut = $('#date_de_debut_db_value').val()
            let dateFin = $('#date_de_fin_db_value').val()
            if (dateDebut) {
                date_de_debut.setAttribute('value', dateDebut);
            }
            if (dateFin) {   
                date_de_fin.setAttribute('value', dateFin);
            }
            const parentElement = document.querySelector('.nb_jours_forfait_td');
            if (parentElement) {
                const eyeSlashElement = parentElement.querySelector('.fa-eye-slash');
                var nb_jours_forfait = fragment.querySelector(
                    ".nb_jours_forfait_td"
                );
                if (eyeSlashElement) {
                    nb_jours_forfait.innerHTML = '<center><i class="far fa-eye-slash" style="font-size: 20px;"></i></center>'
                } else {
                    nb_jours_forfait.innerHTML = `<input size="20" class="input-sm max-w-90" data-reflex="change->bons_de_commandes#update_hm_commande_ressources" data-app="${app}" data-id="${bons_de_commande_id}" data-index="NEW_RECORD" type="text" name="bons_de_commande[ressources_attributes][NEW_RECORD][nb_jours_forfait]" id="bons_de_commande_ressources_attributes_NEW_RECORD_nb_jours_forfait">`
                }

            }
        }
    }

    verifierTouche(event) {
        // KeyCode 13 correspond à la touche Entrée
        if (event.keyCode === 13) {
            event.preventDefault(); // Prévenir le comportement par défaut (soumission du formulaire)
            this.bons_de_commande_interventions_search();
        }
    }





    get params() {
        return this.data.get("params");
    }

    get current_app() {
        return this.data.get("app");
    }




    get bons_de_commande_id() {
        return this.data.get("bons_de_commandeid");
    }

    get filterrific() {
        return this.data.get("filterrific");
    }

    get page() {
        return this.data.get("page");
    }

    get filter_param_id() {
        return this.data.get("filter-param-id");
    }

    get is_active() {
        return this.data.get("is-active");
    }

    get active_tab() {
        return this.data.get("active-tab");
    }



    get url_solution() {
        return this.data.get("urlsolution");
    }
}